import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0 5px 0;

  ${mediaMaxWidth.phone`
    display: none;
  `}
`;

export const Step = styled.div`
  margin: 0 10px;
  width: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepTitle = styled.div`
  font-weight: 100;
  font-size: 0.9em;
  letter-spacing: 0.8px;
  color: ${(props) => (props.active ? "#fff" : "#a56ec9")};
`;

export const StepGraphics = styled.div`
  height: 8px;
  width: 100%;
  height: 6px;
  border-radius: 4px;
  margin: 8px 0;
  background-color: ${(props) => (props.active ? "#fff" : "#a56ec9")};
`;
